
export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 lg:px-20 py-4">
          <div className="flex items-center justify-between">
            <img
              src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
              alt="8028 Private Salon"
              className="h-8 w-auto"
            />
            <nav>
              <a
                href="/"
                className="text-gray-600 hover:text-[#EF9786] transition-colors cursor-pointer"
              >
                ホームに戻る
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-12">
        <div className="container mx-auto px-6 lg:px-20 max-w-4xl">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">8028 GLOBAL SALON プライバシーポリシー</h1>
          <p className="text-sm text-gray-600 mb-8">最終更新日：2025年5月2日</p>
          
          <div className="prose max-w-none">
            <p className="text-gray-700 mb-8 leading-relaxed">
              8028 GLOBAL株式会社（以下「当社」といいます。）は、当社が運営するマッチングプラットフォーム「8028 GLOBAL SALON」（以下「本サービス」といいます。）において取得する個人情報を、以下の方針に基づき適切に取り扱います。
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">1. 適用範囲</h2>
              <p className="text-gray-700 leading-relaxed">
                本ポリシーは、本サービスのウェブサイトおよびモバイルアプリを通じて当社が取得・利用・管理する全ての個人情報に適用されます。歯科衛生士（DH）・歯科医院・一般ユーザー等、利用者区分を問いません。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">2. 取得する個人情報</h2>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-200">
                      <th className="px-6 py-3 text-left font-semibold text-gray-800">区分</th>
                      <th className="px-6 py-3 text-left font-semibold text-gray-800">具体例</th>
                      <th className="px-6 py-3 text-left font-semibold text-gray-800">主な取得タイミング</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <td className="px-6 py-4 text-gray-800 font-medium">登録情報</td>
                      <td className="px-6 py-4 text-gray-700">氏名、フリガナ、生年月日、性別、メールアドレス、電話番号、居住地域</td>
                      <td className="px-6 py-4 text-gray-700">アカウント登録時</td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-6 py-4 text-gray-800 font-medium">決済情報</td>
                      <td className="px-6 py-4 text-gray-700">クレジットカード番号・有効期限（決済代行会社経由）、チケット購入履歴</td>
                      <td className="px-6 py-4 text-gray-700">決済時</td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-6 py-4 text-gray-800 font-medium">健康・施術情報※</td>
                      <td className="px-6 py-4 text-gray-700">既往歴、服薬状況、歯周ポケット測定値、口腔写真、レントゲン画像など</td>
                      <td className="px-6 py-4 text-gray-700">予約時問診票・施術後記録</td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-6 py-4 text-gray-800 font-medium">DH・医院情報</td>
                      <td className="px-6 py-4 text-gray-700">資格証、勤務先、研修受講履歴、収益情報</td>
                      <td className="px-6 py-4 text-gray-700">提携登録時・運用時</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-gray-800 font-medium">ログ・Cookie</td>
                      <td className="px-6 py-4 text-gray-700">IPアドレス、端末識別子、ブラウザ種別、アクセス日時、操作履歴</td>
                      <td className="px-6 py-4 text-gray-700">利用時自動取得</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-gray-600 mt-4">
                ※健康・施術情報は「要配慮個人情報」に該当します。当社は法令に基づく同意取得、暗号化保管、アクセス権限管理を徹底します。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">3. 利用目的</h2>
              <p className="text-gray-700 mb-3">取得した個人情報は、以下の目的で使用します。</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>本サービス（マッチング、予約、決済、レビュー等）の提供・運営</li>
                <li>身分確認・不正利用防止・反社会的勢力排除のため</li>
                <li>問い合わせ対応・トラブル解決・サポート業務のため</li>
                <li>施術品質向上、カウンセリング、予防プラン提案のため</li>
                <li>統計データの作成およびサービス改善</li>
                <li>新サービス・キャンペーン等のご案内（ユーザーは配信停止可）</li>
                <li>法令・ガイドラインに基づく記録保存・行政報告</li>
                <li>上記に付随する業務の遂行</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">4. 第三者提供</h2>
              <p className="text-gray-700 mb-3">当社は、以下の場合を除き、個人情報を第三者に提供しません。</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>本人の同意がある場合</li>
                <li>法令に基づく場合、または公的機関から適法に開示を求められた場合</li>
                <li>人の生命・身体・財産の保護に必要で本人同意取得が困難な場合</li>
                <li>決済代行・クラウド運用など業務委託先に、利用目的達成に必要な範囲で提供する場合（委託先とは守秘義務契約を締結し適切な監督を行います）</li>
                <li>予約成立に必要な範囲でサロンおよびDHへ健康・施術情報を共有する場合（要配慮個人情報取扱い同意を取得した上で実施）</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">5. 個人情報の海外移転</h2>
              <p className="text-gray-700 leading-relaxed">
                国外サーバーを利用する場合、十分な保護水準が認められる国・事業者を選定し、APPI第28条の2に定める必要な措置と契約を講じます。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">6. 安全管理措置</h2>
              <p className="text-gray-700">
                技術的対策：TLS1.2以降による通信暗号化、保存データのAES-256暗号化、二要素認証
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">7. Cookie・広告IDの利用</h2>
              <p className="text-gray-700 leading-relaxed">
                当社はサービス改善や不正検知のためCookieや広告IDを使用します。ユーザーはブラウザの設定でCookieを無効化できますが、一部機能がご利用いただけなくなる場合があります。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">8. 保有個人データの開示等</h2>
              <p className="text-gray-700 leading-relaxed">
                ユーザーは、当社が保有する自身の個人データについて、開示・訂正・削除・利用停止・第三者提供停止を請求できます。所定の手続きにより本人確認後、速やかに対応します（法令に基づき手数料を頂く場合あり）。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">9. 未成年の個人情報</h2>
              <p className="text-gray-700 leading-relaxed">
                未成年者は、親権者等の同意を得て個人情報を提供してください。同意が確認できない場合、登録削除等の措置を行うことがあります。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">10. ポリシーの改定</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、法令改正やサービス内容変更に応じて本ポリシーを改定します。重要な変更時はWebサイト掲載およびメール等で通知します。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-4">11. お問い合わせ窓口</h2>
              <p className="text-gray-700 mb-3">個人情報の取扱いに関するご相談・苦情・開示請求は、下記窓口までご連絡ください。</p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="space-y-2 text-gray-700">
                  <p><strong>8028 GLOBAL株式会社</strong></p>
                  <p>個人情報保護管理者：古市 彰吾</p>
                  <p>所在地：東京都港区芝浦3丁目4番地2号　グランパークハイツ1704</p>
                  <p>E‑mail：support@8028global.jp</p>
                  <p>電話：03-5501-3205（受付時間 平日10:00‑17:00）</p>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-12 text-center">
            <a
              href="/"
              className="inline-flex items-center px-6 py-3 bg-[#EF9786] text-white rounded-full font-semibold hover:bg-[#e8856f] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              ホームに戻る
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 mt-16">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div>
                <img
                  src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
                  alt="8028 Private Salon"
                  className="h-6 w-auto mb-4"
                />
                <p className="text-gray-400 mb-4">
                  歯の健康を守るプロと患者をつなぐプラットフォーム
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">会社情報</h4>
              <div className="space-y-2 text-gray-400">
                <p>運営会社：8028Global Inc</p>
                <p>お問い合わせ：support@8028private.com</p>
                <p>
                  Webサイト：
                  <a
                    href="https://8028private.com"
                    className="hover:text-white transition-colors"
                  >
                    https://8028private.com
                  </a>
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">リンク</h4>
              <div className="space-y-2">
                <div>
                  <a
                    href="/terms"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    利用規約
                  </a>
                </div>
                <div>
                  <a
                    href="/privacy"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    プライバシーポリシー
                  </a>
                </div>
                <div>
                  <a
                    href="/legal"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    特定商取引法に基づく表示
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 8028Global Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
